import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: 'confirm-dialog.component.html',
    styleUrls: ['confirm-dialog.component.scss']
})

export class ConfirmDialogComponent implements OnInit, OnDestroy {
    message: any;
    constructor(
        private confirmDialogService: ConfirmDialogService,
        private el: ElementRef
    ) { }

    ngOnInit(): any {
        // Rendered from the header, whose stacking context sits below Bootstrap modals, so a
        // confirm asked from inside a modal opened behind it. Living on <body> keeps the
        // overlay's z-index above any open modal.
        document.body.appendChild(this.el.nativeElement);
       /**
        *   This function waits for a message from alert service, it gets
        *   triggered when we call this from any other component
        */
        this.confirmDialogService.getMessage().subscribe(message => {
            this.message = message;
        });
    }

    ngOnDestroy(): void {
        this.el.nativeElement.remove();
    }

    // Destructive actions (delete/remove) get a red icon and Yes button
    get isDanger(): boolean {
        return /\b(delete|remove)\b/i.test(this.message?.text || '');
    }
}
